module.exports = __webpack_public_path__ + "img/yingyezhizhao.e6cdcce9.png";